import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
// import * as Cookies from 'js-cookie'


let id = '598c710ca58ad9338a66893d'


import mutations from './mutations'
import getters from './getters'
import state from './state'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
    // plugins: [
    //     createPersistedState({
    //       storage: {
    //         getItem: key => Cookies.get(key),
    //         setItem: (key, value) => Cookies.set(key, value, { expires: 375, domain: `.${window.location.hostname}`}),
    //         removeItem: key => Cookies.remove(key)
    //       }
    //     })
    // ]
})